import jwtDecode from "jwt-decode";

export function checkRolePermission(type = "", permission = "") {
  if (!type || !permission) return false;

  const token = localStorage.getItem("myToken");
  if (!token) return false;

  const d = jwtDecode(token);
  if (!d || !d.permission) return false;

  const dPermission = d.permission;
  if (!dPermission[type]) return false;

  if (dPermission[type].split(",").indexOf(permission) === -1) return false;

  return true;
}



// WEBPACK FOOTER //
// ./src/services/permission.js